import styled from 'styled-components';

import { GridContainer } from '@xing-com/grid';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  xdlPaletteWhite,
  spaceL,
  spaceXL,
  scale100,
  scale120,
  scale220,
  scale250,
} from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

export const StyledGridContainer = styled(GridContainer)`
  margin: 0 0 ${scale220};

  @media ${mediaConfined} {
    margin: 0 0 ${scale250};
  }
`;

export const ImagesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  align-items: center;

  @media ${mediaConfined} {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }
`;

export const StyledHero = styled(Hero)`
  position: relative;
  grid-column: 1/-1;
  grid-row: 1/2;
  color: ${xdlPaletteWhite};
  margin: 0;
  padding-left: ${spaceL};
  max-width: 225px;

  @media ${mediaConfined} {
    max-width: 246px;
    grid-column: 1/2;
    grid-row: 1/-1;
    padding-left: ${spaceXL};
    max-width: 280px;
  }
`;

export const Image = styled.img`
  display: block;
  width: 100%;
`;

export const FirstImage = styled(Image)`
  grid-column: 1/-1;
  grid-row: 1/2;

  @media ${mediaConfined} {
    grid-column: 1/2;
    grid-row: 1/-1;
  }
`;

export const SecondImage = styled(Image)`
  grid-column: 1/-1;
  grid-row: 2/3;
  padding-top: ${scale100};

  @media ${mediaConfined} {
    grid-column: 2/-1;
    grid-row: 1/-1;
    padding-top: 0;
    padding-left: ${scale120};
  }
`;
